import script from "./TabCensus.vue?vue&type=script&setup=true&lang=js"
export * from "./TabCensus.vue?vue&type=script&setup=true&lang=js"

import "./TabCensus.vue?vue&type=style&index=0&id=642db268&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642db268"]])

export default __exports__